export default "__VITE_ASSET__BAN8d1hP__"